import { useEffect } from 'react'

import { syncPendoVisitorPreferences } from 'utils/pendo'

import { useTheme } from './context/ThemeContext'

export default function PendoVisitorSync() {
  const { theme, effectiveTheme } = useTheme()

  useEffect(() => {
    syncPendoVisitorPreferences({
      themePreference: theme,
      effectiveTheme,
    })
  }, [theme, effectiveTheme])

  return null
}
